import { useLocation } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import { Button } from "@/components/ui/button";
import { useMediaQuery } from "@/hooks/use-media-query";
import { cn } from "@/lib/utils";

interface FloatingActionButtonProps {
  onClick: () => void;
  label: string;
  className?: string;
}

export function FloatingActionButton({ onClick, label, className }: FloatingActionButtonProps) {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const location = useLocation();

  const showOnPaths = ["/players", "/matches"];
  if (!isMobile || !showOnPaths.includes(location.pathname)) {
    return null;
  }

  return (
    <Button
      size="icon"
      className={cn(
        "fixed right-4 z-40 h-14 w-14 rounded-full shadow-lg bg-soccer-primary hover:bg-soccer-primary/90 text-white",
        "bottom-[calc(4.5rem+env(safe-area-inset-bottom))]",
        className
      )}
      onClick={onClick}
      aria-label={label}
    >
      <FaPlus className="h-6 w-6" />
    </Button>
  );
}
